module.exports = __webpack_public_path__ + "static/media/villa.294ebea8.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/villa.JPG
// module id = 693
// module chunks = 0